var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-item"},[_c('span',{class:[
      {selected: _vm.selected},
      {clickable: _vm.clickable},
      'menu-select',
      {'has-children': _vm.hasChildren},
      {'child-selected': _vm.childSelected}  
    ],on:{"click":function($event){return _vm.$emit('select-click', _vm.id)}}},[_vm._v(" "+_vm._s(_vm.text)+" ")]),(_vm.hasChildren)?_c('div',{class:{clickable: _vm.clickable, 'icon-open': _vm.isOpen, 'icon-close': !_vm.isOpen, open: _vm.isOpen},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('nav-click', _vm.id)}}},[_c('arrow-down')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }